import { useMutation } from '@tanstack/react-query';

import { fetchWithCsrfTokenFormData } from 'utils/fetchWrapper';

export interface CreateSupplementalMaterialsVariables {
  interviewUid: string;
  file: Blob;
  description: string;
  name: string;
}

interface CreateSupplementalMaterialsResponse {
  download_link: string;
  supplemental_materials_description: string;
  supplemental_materials_name: string;
}

const useCreateSupplementalMaterials = () => {
  const {
    mutateAsync: createSupplementalMaterials,
    data,
    isLoading,
    error,
  } = useMutation<
    CreateSupplementalMaterialsResponse,
    Error,
    CreateSupplementalMaterialsVariables
  >(
    ['createSupplementalMaterials'],
    async ({ interviewUid, file, name, description }) => {
      const body = new FormData();
      body.append('interview', interviewUid);
      body.append('supplemental_file', file);
      body.append('supplemental_materials_name', name);
      body.append('supplemental_materials_description', description);
      const response =
        await fetchWithCsrfTokenFormData<CreateSupplementalMaterialsResponse>(
          'builder/async/supplemental_materials/update',
          'POST',
          body
        );

      return response;
    }
  );

  return {
    createSupplementalMaterials,
    data,
    isLoading,
    error,
  };
};

export default useCreateSupplementalMaterials;
